/* What a message is about — the words, the colour and the sign */
export const TYPES = {
    organization: { text: "Жалоба на точку", short: "На точку", accent: "red", icon: "organization" },
    review: { text: "Жалоба на отзыв", short: "На отзыв", accent: "orange", icon: "review" },
    support: { text: "Обращение клиента", short: "Клиенты", accent: "blue", icon: "support" },
    member: { text: "Сообщение мастера", short: "Мастера", accent: "violet", icon: "profile" }
}

export const typeOf = key => TYPES[key] ? TYPES[key] : TYPES.support

/* The way of a case: nobody looked → in work → resolved */
export const STATUSES = {
    new: { text: "Новое", accent: "blue", icon: "notification" },
    progress: { text: "В работе", accent: "orange", icon: "clock" },
    done: { text: "Решено", accent: "green", icon: "check" }
}

export const statusOf = key => STATUSES[key] ? STATUSES[key] : STATUSES.new

/* The roles of the team in the words of the points */
export const ROLES = {
    owner: "Владелец",
    admin: "Администратор",
    specialist: "Специалист"
}
